import { Link } from 'react-router-dom';
import { ButtonBase } from '@mui/material';
import HeaderLogo from './HeaderLogoMain';
import HeaderLogoIcon from './HeaderLogoIcon';
import { APP_DEFAULT_PATH } from 'config';
import { LogoSectionProps } from 'types/components';

const HeaderLogoSection = ({ reverse, isIcon, sx, to, disabled }: LogoSectionProps) => (
    <ButtonBase disableRipple component={Link} to={!to ? APP_DEFAULT_PATH : to} disabled={disabled} sx={sx}>
        {isIcon ? <HeaderLogoIcon /> : <HeaderLogo reverse={reverse} />}
    </ButtonBase>
);

export default HeaderLogoSection;
